import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/TondoCorp-Regular.woff'
import './fonts/TondoCorp-Bold.woff'
import './fonts/TondoCorp-Bold.woff'
import './fonts/TondoCorp-Regular.ttf'
import './fonts/TondoCorp-Bold.ttf'
import './fonts/TondoCorp-Bold.ttf'
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
